"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTeamById = exports.teams = void 0;

var actions = _interopRequireWildcard(require("../constants"));

var _helpers = require("../helpers");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// Initial State
var initialState = {
  byId: {},
  order: [],
  currentTeam: undefined,
  hasFetched: false
};

var teams = function teams(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  var currentTeam;

  switch (action.type) {
    case actions.USER_TEAMS_LOAD_REQUEST:
      return _extends({}, state, {
        hasFetched: false
      });

    case actions.USER_TEAMS_LOAD_SUCCESS:
      // Check if user has teams
      if (action.payload.order.length > 0) {
        // Check if current team is set in state
        if (state.currentTeam) {
          currentTeam = state.currentTeam; // Check if current team is set in cookie
        } else if ((0, _helpers.getCurrentTeamId)()) {
          currentTeam = (0, _helpers.getCurrentTeamId)();
        } // Check if user belongs to current team


        if (!currentTeam || !action.payload.order.find(function (t) {
          return t === Number(currentTeam);
        })) {
          currentTeam = action.payload.order[0];
        }

        if (currentTeam) {
          (0, _helpers.saveTeamToCookie)(currentTeam.toString());
        }
      } else {
        currentTeam = null;
        (0, _helpers.saveTeamToCookie)('0');
      }

      return _extends({}, state, action.payload, {
        currentTeam: currentTeam,
        hasFetched: true
      });

    case actions.USER_TEAMS_LOAD_FAILURE:
      return _extends({}, state, {
        hasFetched: true
      });

    case actions.USER_TEAM_CHANGE:
      (0, _helpers.saveTeamToCookie)(action.currentTeam.toString());
      return _extends({}, state, {
        currentTeam: action.currentTeam
      });

    case actions.USER_ORGANISATION_CHANGE:
      return initialState;

    case actions.LOG_OUT_SUCCESS:
      return initialState;

    default:
      return state;
  }
};

exports.teams = teams;

var getTeamById = function getTeamById(state, props) {
  return state.auth.teams.byId[props.match.params.mapId];
};

exports.getTeamById = getTeamById;